import type { SchemaField } from '../../../../types/schede'
import FieldWrapper from './FieldWrapper'

interface RadioFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function RadioField({ field, value, onChange, readOnly, error }: RadioFieldProps) {
  return (
    <FieldWrapper field={field} error={error}>
      <div className="flex flex-col gap-1.5 mt-0.5">
        {field.options?.map((opt) => (
          <label key={opt.value} className="flex items-center gap-2 cursor-pointer text-sm">
            <input
              type="radio"
              name={field.id}
              value={opt.value}
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
              disabled={readOnly}
              className="w-4 h-4"
              style={{
                accentColor: 'var(--color-primary, #3b82f6)',
              }}
            />
            <span style={{ color: 'var(--color-text-primary)' }}>{opt.label}</span>
          </label>
        ))}
      </div>
    </FieldWrapper>
  )
}
